import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AuthGuard, ConfigModule, I18nModule} from '@spartacus/core';
import {SelectionTypeB2BComponent} from './select-type.component';
import {CommonModule} from '@angular/common';
import {UserRegistrationDoneGuard} from '@app/checkout/guards/user-registration-done.guard';
import {CcRestrictedCountryIframeComponent} from './cc-restricted-country-iframe/cc-restricted-country-iframe.component';

import {CustomerNameModule} from '@app/registration/customer-name/customer-name.module';

@NgModule({
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SelectionTypeB2BComponent: {
          component: SelectionTypeB2BComponent,
          guards: [AuthGuard, UserRegistrationDoneGuard],
        },
      },
    }),
    I18nModule,
    CustomerNameModule,
    SelectionTypeB2BComponent,
    CcRestrictedCountryIframeComponent,
  ],
  exports: [SelectionTypeB2BComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SelectTypeB2BModule {}
